// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2ypfj","tab":"Tabs_tab__2cwX_","tabActive":"Tabs_tabActive__2Z-q5"};